import React, { useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/oportunidades/header/Header";
import Midia from "../../components/oportunidades/midia/Midia";
import DetalhesOportunidade from "../../components/oportunidades/detalhesOportunidade/DetalhesOportunidade";
import ActionFooter from "../../components/actionFooter/ActionFooter";
import { DashboardLayout, MainContent } from "../dash/styles";
import { Container } from "./styles";
import dayjs from "dayjs";

export default function CriarOportunidades() {
  const navigate = useNavigate();

  const [oportunidadeData, setOportunidadeData] = useState({
    titulo: "",
    descricao: "",
    organizador: "",
    empresa: "",
    cargo: "",
    local: "",
    status: "Upcoming",
    salario: "",
    horaTrabalho: "",
    dataInicio: null,
    dataFim: null,
    destacado: false,
    conteudos: [{ titulo: "", itens: [""] }],
    contatos: [{ telefone: "", email: "", redeSocial: "" }],
    imagem: null,
    preview: "",
    vagas: null,
    sobreEmpresa: "",
    likes: 0,
  });

  const handleSave = async () => {
    // Valida campos obrigatórios
    if (
      !oportunidadeData.titulo ||
      !oportunidadeData.empresa ||
      !oportunidadeData.cargo ||
      !oportunidadeData.dataInicio ||
      !oportunidadeData.dataFim
    ) {
      alert(
        "Por favor, preencha título, empresa, cargo e datas de início e fim."
      );
      return;
    }

    const formData = new FormData();

    // ---------------- CAMPOS PRINCIPAIS ----------------
    formData.append("titulo", oportunidadeData.titulo);
    formData.append("descricao", oportunidadeData.descricao);
    formData.append("organizador", oportunidadeData.organizador);
    formData.append("empresa", oportunidadeData.empresa);
    formData.append("cargo", oportunidadeData.cargo);
    formData.append("local", oportunidadeData.local);
    formData.append("status", oportunidadeData.status);
    formData.append("salario", oportunidadeData.salario);
    formData.append("horaTrabalho", oportunidadeData.horaTrabalho);

    formData.append(
      "dataInicio",
      dayjs(oportunidadeData.dataInicio).toISOString()
    );
    formData.append("dataFim", dayjs(oportunidadeData.dataFim).toISOString());

    // ---------------- ARRAYS ----------------
    formData.append("conteudos", JSON.stringify(oportunidadeData.conteudos));
    formData.append("contatos", JSON.stringify(oportunidadeData.contatos));

    // ---------------- BOOLEANOS E OUTROS ----------------
    formData.append("destacado", String(oportunidadeData.destacado));
    formData.append(
      "vagas",
      oportunidadeData.vagas !== null ? String(oportunidadeData.vagas) : "null"
    );
    formData.append("sobreEmpresa", oportunidadeData.sobreEmpresa);
    formData.append("likes", String(oportunidadeData.likes || 0));

    // ---------------- IMAGEM ----------------
    if (oportunidadeData.imagem instanceof File) {
      formData.append("imagem", oportunidadeData.imagem);
    }

    try {
      console.log("Enviando dados da oportunidade:", oportunidadeData);
      const response = await api.post("/api/content/oportunidades", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Oportunidade criada com sucesso!");
      navigate("/oportunidades");
    } catch (error) {
      console.error("Erro ao salvar oportunidade:", error);
      alert("Erro ao criar oportunidade. Verifique o backend.");
    }
  };

  return (
    <DashboardLayout>
      <Sidebar />

      <Container>
        <Header
          title="Criar uma nova oportunidade"
          description="Adicione uma nova oportunidade à plataforma"
          breadcrumbMain="oportunidades"
          breadcrumbCurrent="Criar oportunidade"
        />

        <MainContent>
          <Midia
            initialPreview={oportunidadeData.preview}
            onFileSelect={(file, preview) =>
              setOportunidadeData({
                ...oportunidadeData,
                imagem: file,
                preview: preview,
              })
            }
          />

          <DetalhesOportunidade
            oportunidadeData={oportunidadeData}
            setOportunidadeData={setOportunidadeData}
          />

          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
